

























































export default {
  seo: {
    title: 'Page Not Found',
  },
  components: {},
  data() {
    return {};
  },
};
